import gql from 'graphql-tag';
import { BookingsFragmentInclude } from './Bookings';

export default gql`
    fragment GraveLedger on Funeral {
        GraveLedger {
            ${BookingsFragmentInclude}
        }
    }
`;
